<template>
  <div class="prefs container">
    <h1 class="purple">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="38"
        height="42"
        viewBox="0 0 37.7 41.8"
      >
        <!-- eslint-disable-next-line max-len -->
        <path
          class="st0"
          d="M34.2 41.8H3.5C1.5 41.8 0 40.3 0 38.4c0-0.1 0.1-1.5 0.7-3.6 0.7-2.6 6.3-4.5 11.7-6.1l0.7-0.2c0.5-0.1 1-1.6 1.1-3.7 -0.6-0.5-1.1-1.1-1.6-1.9 -0.1-0.2-0.3-0.5-0.4-0.7 -0.5-0.8-1-1.5-1.4-2.6 -0.5-0.2-0.9-0.5-1.1-1 -0.9-1.6-1.4-4.2-1-5.2 0.2-0.4 0.5-0.8 1-0.9 0-3.8 1.3-6.2 2.6-7.7 0-0.1 0-0.3 0-0.4 0.4-1.3 1.6-1.9 2.8-2 0-0.2 0.1-0.5 0.2-0.7 0.2-0.6 0.8-1.4 1.4-1.6 0.2 0 0.4 0 0.5 0.1 0.2 0.1 0.3 0.3 0.3 0.5 0 0.1 0.5 0.4 1.1 0.6 1.7 0.5 2.9 0.9 3.6 1.3 3.6 1.4 5.8 5.2 5.8 10 0.4 0.2 0.7 0.5 0.9 0.9 0.4 1-0.1 3.6-1 5.3 -0.2 0.4-0.6 0.8-1 1 -0.4 1-0.9 1.8-1.4 2.6 -0.1 0.2-0.3 0.5-0.4 0.7 -0.5 0.8-0.9 1.3-1.4 1.8 0.1 2 0.5 3.6 1.1 3.8 1 0.4 2.2 0.8 3.5 1.2 4 1.2 8.1 2.5 8.8 5.1 0.6 2.2 0.7 2.9 0.7 3.6C37.7 40.3 36.1 41.8 34.2 41.8zM10.3 13.7c-0.2 0-0.3 0.1-0.3 0.1 -0.2 0.5 0.2 2.6 0.9 4.1 0.1 0.2 0.3 0.4 0.4 0.4 0.3 0 0.6 0.2 0.7 0.5 0.4 1.1 0.8 1.8 1.4 2.6 0.1 0.2 0.3 0.5 0.4 0.7 0.5 0.8 1 1.3 1.5 1.7 0.2 0.1 0.3 0.4 0.3 0.6 0 1.4-0.3 4.9-2.1 5.4l-0.7 0.2c-6.7 2-10.3 3.7-10.7 5.1 -0.5 2-0.6 3.3-0.6 3.3 0 1.1 0.9 2 2 2h30.8c1.1 0 2-0.9 2-2 0-0.6-0.1-1.1-0.6-3.3 -0.5-1.8-4.5-3.1-7.8-4.1 -1.3-0.4-2.6-0.8-3.7-1.2 -1.7-0.7-2-3.7-2-5.5 0-0.2 0.1-0.4 0.3-0.6 0.4-0.3 0.9-0.9 1.3-1.6 0.2-0.3 0.3-0.5 0.5-0.7 0.5-0.8 1-1.6 1.4-2.6 0.1-0.2 0.3-0.4 0.6-0.5 0.1 0 0.3-0.1 0.4-0.4 0.8-1.5 1.1-3.6 0.9-4.1 0 0-0.1 0-0.2 0 -0.2 0-0.4-0.1-0.5-0.2s-0.2-0.3-0.2-0.5c0.2-4.6-1.6-7.9-4.9-9.2 -0.7-0.3-1.8-0.8-3.4-1.2 -0.5-0.1-1.1-0.4-1.6-0.8 -0.1 0.2-0.2 0.4-0.2 0.5 0 0.1 0 0.2 0 0.2 0.2 0.2 0.2 0.6 0 0.8 -0.1 0.2-0.4 0.3-0.6 0.3h-0.1c-0.1 0-1.1 0-1.7 0.4 0 0 0 0.1 0 0.1 0.1 0.3 0.1 0.6-0.2 0.8 -1.4 1.2-3 3.6-2.8 8 0 0.2-0.1 0.4-0.2 0.5 -0.1 0.1-0.3 0.2-0.5 0.2H10.3z"
        />
      </svg>
      העדפות
    </h1>
    <div v-if="$route.name === 'newuser'" class="prefs-welcome">
      <p><strong>שמחים שהצטרפת אלינו! עוד רגע נתחיל לתרגל יחד,</strong></p>
      <p><strong>חשוב שנדע יחד מה חשוב לך להשיג בעזרת YOGANOW😊</strong></p>
      <p>
        <strong
          >נשמח לדעת מה המטרות שלך בכדי להציע לך את השיעורים המתאים
          ביותר</strong
        >
      </p>
    </div>

    <div class="pref-items">
      <div class="columns">
        <div class="column">
          <h5>נשמח לדעת מה המטרות שלך לתרגול עם YOGANOW</h5>
        </div>
        <div class="column is-half">
          <checkbox-container
            :options="intConfig"
            config="interestConfig"
          ></checkbox-container>
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <h5>איזה תחומי תרגול מעניינים אותך?</h5>
        </div>
        <div class="column is-half">
          <checkbox-container
            :options="currentConfig"
            config="currentConfig"
          ></checkbox-container>
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <h5>איזו רמה של שיעורים כדאי שנציע לך?</h5>
        </div>
        <div class="column is-half">
          <checkbox-container
            :options="xpConfig"
            config="xpConfig"
            :single="true"
          ></checkbox-container>
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <h5>מה קצב השיעור המועדף עלייך?</h5>
        </div>
        <div class="column is-half">
          <checkbox-container
            :options="tempoConfig"
            config="tempoConfig"
            :single="true"
          ></checkbox-container>
        </div>
      </div>
      <hr />

      <div class="columns">
        <div class="column">
          <h5>מה אורך התרגול הממוצע שמתאים לך?</h5>
        </div>
        <div class="column is-half">
          <checkbox-container
            :options="durationConfig"
            config="durationConfig"
            :single="true"
          ></checkbox-container>
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column has-text-left">
          <button class="yoga-btn-beige" @click="saveConfig()">שמור</button>
        </div>
      </div>

      <div class="columns" v-if="$route.name === 'newuser'">
        <div class="column has-text-centered">
          <router-link :to="{ name: 'home' }" class="yoga-btn-purple"
            >המשך לאימון שלי</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxContainer from "@/components/account/CheckboxContainer.vue";

export default {
  name: `Preferences`,

  components: {
    CheckboxContainer,
  },

  computed: {
    xpConfig() {
      return this.$store.state.user.xpConfig;
    },
    intConfig() {
      return this.$store.state.user.interestConfig;
    },
    currentConfig() {
      return this.$store.state.user.currentConfig;
    },
    durationConfig() {
      return this.$store.state.user.durationConfig;
    },
    tempoConfig() {
      return this.$store.state.user.tempoConfig;
    },
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
  },

  methods: {
    saveConfig() {
      this.$store.dispatch(`setConfig`);

      if (this.$route.name === `newuser`) {
        if (this.xpConfig[0].selected) {
          this.$store.dispatch(`addToBeginnerList`);
        }
      }
    },
  },

  //   created() {
  //     if (this.isLoggedIn === 0) {
  //       this.$router.push(`/profile`);
  //     }
  //   },
};
</script>

<style lang="scss">
$purple: #656b85;

.prefs {
  padding-top: 20px;

  .columns {
    margin-right: 0;
  }

  h1 {
    margin: 20px 0 0;
    padding-right: 15px;
  }
  p {
    color: $purple;
    margin: 0 0 20px;
  }
  .yoga-btn-purple {
    margin-bottom: 20px;
  }
}

.pref-items {
  max-width: 1200px;
  h5 {
    font-weight: bold;
    color: $purple;
  }
}

.prefs-welcome {
  margin-bottom: 2em;
  p {
    margin: 0;
  }
}

@media screen and (min-width: 1025px) {
  .prefs {
    .columns {
      margin-right: -0.75rem;
    }
    h1 {
      padding-right: 0;
    }
  }
}
</style>
